import styled from "styled-components";

export const Style = styled.div`
  @keyframes rotate {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  .wrap {
    width: 100vw;
    height: 100vh;
    background: #000;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 25% 0 0 0;
  }

  .callStatusWrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 30px;

    h2 {
      font-size: 48px;
      font-weight: 600;
      margin-bottom: 8vh;
    }

    h4 {
      font-size: 28px;
      font-weight: 500;
      text-align: center;
      white-space: pre-line;
    }
    h4.callTime {
      font-family: "Pretendard", sans-serif;
      font-variant-numeric: tabular-nums;
    }
  }

  .footerWrap {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .buttonWrap {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 40vw;
    }

    button {
      p {
        font-size: 24px;
        font-weight: 500;
        margin: 20px 0;
      }
      img {
        width: 100px;
        height: 100px;
        padding: 14px;
        background: #ff3030;
        border-radius: 50%;
      }
      img.call {
        background: #009712;
        rotate: -135deg;
      }
    }

    p.hotelName {
      width: fit-content;
      font-size: 20px;
      line-height: 30px;
      font-weight: 400;
      color: #555;
      background: #fff;
      border-radius: 20px 20px 0 0;
      padding: 10px 24px;
      margin: 8vh 0 0 0;
    }
  }
`;
